import {on} from 'delegated-events'

on('click', '.js-split-diff-view', function () {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const unifiedDiffViewBox = document.querySelector<HTMLElement>('.js-unified-diff-view-box')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const splitDiffViewBox = document.querySelector<HTMLElement>('.js-split-diff-view-box')!

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const splitDiffViewOption = document.querySelector<HTMLInputElement>('.js-split-diff-view-option')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const unifiedDiffViewOption = document.querySelector<HTMLInputElement>('.js-unified-diff-view-option')!

  splitDiffViewBox.classList.add('color-border-accent-emphasis')
  splitDiffViewBox.classList.remove('color-border-default')

  unifiedDiffViewBox.classList.remove('color-border-accent-emphasis')
  unifiedDiffViewBox.classList.add('color-border-default')

  unifiedDiffViewOption.checked = false
  splitDiffViewOption.checked = true
})

on('click', '.js-unified-diff-view', function () {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const unifiedDiffViewBox = document.querySelector<HTMLElement>('.js-unified-diff-view-box')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const splitDiffViewBox = document.querySelector<HTMLElement>('.js-split-diff-view-box')!

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const splitDiffViewOption = document.querySelector<HTMLInputElement>('.js-split-diff-view-option')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const unifiedDiffViewOption = document.querySelector<HTMLInputElement>('.js-unified-diff-view-option')!

  splitDiffViewBox.classList.remove('color-border-accent-emphasis')
  splitDiffViewBox.classList.add('color-border-default')

  unifiedDiffViewBox.classList.add('color-border-accent-emphasis')
  unifiedDiffViewBox.classList.remove('color-border-default')

  unifiedDiffViewOption.checked = true
  splitDiffViewOption.checked = false
})
